<template>
  <router-view v-if="isInit" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { CurrentCountryType, CurrentLanguageType, useLanguageStore } from '@/store/modules/language'
import { LangType, langs } from '@/i18n'
import { LANGUAGE_CONFIG_MAP, COUNTRY_CONFIG } from '@/hooks/useCommonConfig'
import { useCommonStatus } from '@/store/modules/commonStaus'
import { CommonConstants } from '@/common/constants'
import { apiGameCountry } from '@/api/gameApi'
import { useChangeLangHooks } from '@/i18n/useChangeLangHooks'

const { setCurrentLanguage, setCurrentCountry } = useLanguageStore()
const { currentLanguage } = storeToRefs(useLanguageStore())
const router = useRouter()
const route = useRoute()
const isInit = ref(false)
const { isMoyuApp, deferredPrompt } = storeToRefs(useCommonStatus())
const { loadMoyuJsSdk } = useCommonStatus()
const { changeLang } = useChangeLangHooks()

const getCurrentLanguage = (key: LangType): CurrentLanguageType | undefined => {
  return LANGUAGE_CONFIG_MAP.find(item => item.key === key)
}

const getCurrentCountry = (key: string): CurrentCountryType | undefined => {
  return COUNTRY_CONFIG.find(item => item.key === key) || COUNTRY_CONFIG[COUNTRY_CONFIG.length - 1]
}

const setInfoLanguage = () => {
  if (CommonConstants.IS_AREA === 'cn') {
    const lang: LangType = 'zh'
    setCurrentLanguage({
      label: '中文',
      key: 'zh'
    })
    changeLang(lang)
    return
  }
  let lang: LangType = 'en'
  if (currentLanguage.value.key) {
    try {
      lang = currentLanguage.value.key as LangType
    } catch (e) {
      lang = navigator.language.slice(0, 2).toLowerCase() as LangType
    }
  } else {
    lang = navigator.language.slice(0, 2).toLowerCase() as LangType
  }

  // 不在语言列表的，默认第一个语言
  if (!langs.includes(lang as any)) {
    lang = langs[0] as LangType
  }
  setCurrentLanguage(getCurrentLanguage(lang) || LANGUAGE_CONFIG_MAP[0])
  changeLang(lang)
}

// 处理初始化，判断是否在摸鱼社APP
const handleInit = async () => {
  // 添加全局路由实例变量
  window.globalRoute = route
  const source = route.query.source || ''
  const tid = route.query.tid || ''
  const ri = route.query.ri || ''
  const pri = route.query.pri || ''
  if (source) {
    localStorage.setItem('source', source.toString())
  }
  if (tid) {
    localStorage.setItem('hero_tid', tid.toString())
  }

  if(ri) {
    localStorage.setItem('hero_ri', ri.toString())
  }

  if(pri) {
    localStorage.setItem('hero_pri', pri.toString())
  }

  return new Promise(resolve => {
    if (!isMoyuApp.value) {
      resolve(true)
      return
    }
    resolve(true)
    console.log("摸鱼社初始化开始")
    loadMoyuJsSdk(route.path, () => {
      console.log("摸鱼社初始化成功")
      resolve(true)
    })
  })
}

const handleBeforeInstallPrompt = (e: Event) => {
  e.preventDefault();
  deferredPrompt.value = e;
};

onMounted(async () => {
  console.log("APP_MOUNTED", window.location)
  const DOMAIN_TITLE_MAP: Record<string, string> = {
    'xxyzshopbuy.zealshow.com': '咻咻勇者支付中心',
  }
  const hostname = window.location.hostname
  const matchedDomain = Object.keys(DOMAIN_TITLE_MAP).find(domain => hostname.includes(domain))
  document.title = matchedDomain
    ? DOMAIN_TITLE_MAP[matchedDomain]
    : CommonConstants.IS_CN ? '英雄游戏支付中心' : 'Hero Games Store'

  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

  await router.isReady()

  if(route.query.theme === 'light') {
    document.body!.className = 'theme-light'
  } else {
    document.body!.className = 'theme-dark'
  }
  console.log("初始化开始")
  await handleInit()

  setInfoLanguage()
  if (CommonConstants.IS_AREA === 'cn') {
    setCurrentCountry({
      label: 'i18n-zh',
      key: 'CN'
    })
    isInit.value = true
    return
  }

  // 新全球国际化
  const result: any = await apiGameCountry()
  if (result.code === 0) {
    if (result.data.regionCode === 'CN') {
      setCurrentCountry(COUNTRY_CONFIG[COUNTRY_CONFIG.length - 1])
      isInit.value = true

      return
    }
    setCurrentCountry(
      getCurrentCountry(result.data.regionCode) || COUNTRY_CONFIG[COUNTRY_CONFIG.length - 1]
    )
  } else {
    setCurrentCountry(COUNTRY_CONFIG[COUNTRY_CONFIG.length - 1])
  }
  isInit.value = true

})
</script>
